import { useList } from '@refinedev/core';

export type Company = {
  id: string;
  name: string;
  tenantName: string;
  fcaFirmReferenceNumbers?: { id: string; number: string }[];
  clientsCount: number;
};

export const useCompanies = () => {
  const { data, isLoading, isError, error } = useList<Company>({
    resource: 'admin/companies',
  });

  return {
    companies: data?.data,
    isLoading,
    isError,
    error,
  };
};
